
import { useState } from 'react';
import { Docs } from '../docss/docs';
import { Entity } from '../entity/entity';
import './docsanfentitywrapper.css';

export const Docsanfentitywrapper = ()=>{

    const [swap, setSwap] = useState(false);

    const showEntity = ()=>{
        setSwap(true)
    }



    return(<>
        <div className='doccsanndentttity'>

            {
                !swap ? 

                    <Docs 
                        showEntity={showEntity}
                        swap={swap}
                    />

                :

                    <Entity />
            }

        </div>
    </>)
};